// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { testTemplateId } from './TestTemplate';
import { operatorId } from './Operator';
import { z } from 'zod';
export const testTemplateRelationId = (z.number());
export const testTemplateRelation = z.object({
    id: testTemplateRelationId,
    template_a_id: testTemplateId,
    template_b_id: testTemplateId,
    reason: z.string().nullable(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
});
export const testTemplateRelationInitializer = z.object({
    id: testTemplateRelationId.optional(),
    template_a_id: testTemplateId,
    template_b_id: testTemplateId,
    reason: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
export const testTemplateRelationMutator = z.object({
    id: testTemplateRelationId.optional(),
    template_a_id: testTemplateId.optional(),
    template_b_id: testTemplateId.optional(),
    reason: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=TestTemplateRelation.js.map